export default "__VITE_ASSET__oMydHwUr__"